import { isMobile } from "react-device-detect";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  default as Banner,
  default as BannerMobile,
} from "../../assets/images/banner.svg";
import { Container } from "./styles";


export function Slider() {
  return (
    <div id="slider">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        style={{
          "--swiper-navigation-color": "#FFF",
          "--swiper-navigation-size": "30px",
          "--swiper-pagination-color": "#FFF",
          "--swiper-pagination-bullet-inactive-color": "#FFF",
          "--swiper-pagination-bullet-inactive-opacity": "0.4",
        }}
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Pagination, Navigation]}
      >
        <SwiperSlide>
          <Container>
            <img
              className="slide-image"
              src={isMobile ? BannerMobile : Banner}
              alt="Banner"
            />
            <div className="gradient-overlay" />
          </Container>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
